import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { SearchBox, useSearchBox } from 'react-instantsearch';
import './CustomSearchBox.scss';

interface CustomSearchBoxProps {
  autoFocus?: boolean;
  placeholder?: string;
  initialQuery: string;
  isMobile: boolean;
}

const CustomSearchBox: React.FC<CustomSearchBoxProps> = ({ autoFocus, placeholder, initialQuery, isMobile }) => {
  const searchBox = useSearchBox();
  const [initialSearch, setInitialSearch] = useState(false);
  const history = useHistory();

  useEffect(() => {
    if (!initialSearch && initialQuery) {
      setInitialSearch(true);
      searchBox.query = initialQuery;
      searchBox.refine(initialQuery);
    }
    // searchBox is excluded to prevent infinite loops - it's recreated on every render
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialQuery, initialSearch]);

  const handleSearchBlur = () => {
    const searchParams = new URLSearchParams(window.location.search);
    if (searchBox.query) {
      searchParams.set('q', searchBox.query);
    } else {
      searchParams.delete('q');
    }
    const newPath = `${searchParams.toString() ? `/search?${searchParams.toString()}` : '/search'}`;
    history.push(newPath);
  };

  return (
    <SearchBox
      className={isMobile ? 'search-input-mobile' : ''}
      autoCorrect='off'
      id='search-input'
      autoFocus={autoFocus}
      placeholder={placeholder}
      onBlur={handleSearchBlur}
    />
  );
};

export default CustomSearchBox;
